// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#scene-explorer-host {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
}
#scene-explorer-host:focus {
  outline: none;
}

#__resizable_base__ {
  display: none;
}

.context-menu {
  background: #222222;
}
.context-menu .react-contextmenu-item {
  padding: 10px;
  cursor: pointer;
}
.context-menu .react-contextmenu-item:hover {
  background: #555555;
}

.react-contextmenu.context-menu.react-contextmenu--visible {
  z-index: 99;
  transform: scale(1);
}

#sceneExplorer {
  background: #333333;
  height: 100%;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-rows: auto 1fr;
  font: 14px "Arial";
}
#sceneExplorer:focus {
  outline: none;
}
#sceneExplorer #header {
  height: 30px;
  font-size: 16px;
  color: white;
  background: #222222;
  grid-row: 1;
  text-align: center;
  display: grid;
  grid-template-columns: 30px 1fr 50px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
#sceneExplorer #header #logo {
  position: relative;
  grid-column: 1;
  width: 24px;
  height: 24px;
  left: 0;
  display: flex;
  align-self: center;
  justify-self: center;
}
#sceneExplorer #header #title {
  grid-column: 2;
  display: grid;
  align-items: center;
  text-align: center;
}
#sceneExplorer #header #commands {
  grid-column: 3;
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr;
}
#sceneExplorer #header #commands .expand {
  grid-column: 1;
  display: grid;
  align-items: center;
  justify-items: center;
  cursor: pointer;
}
#sceneExplorer #header #commands .close {
  grid-column: 2;
  display: grid;
  align-items: center;
  justify-items: center;
  cursor: pointer;
}
#sceneExplorer #tree {
  grid-row: 2;
  overflow-x: hidden;
  overflow-y: auto;
}
#sceneExplorer .filter {
  display: flex;
  align-items: stretch;
}
#sceneExplorer .filter input {
  width: 100%;
  margin: 10px 40px 5px 40px;
  display: block;
  border: none;
  padding: 0;
  border-bottom: solid 1px rgb(51, 122, 183);
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 96%, rgb(51, 122, 183) 4%);
  background-position: -1000px 0;
  background-size: 1000px 100%;
  background-repeat: no-repeat;
  color: white;
}
#sceneExplorer .filter input::placeholder {
  color: lightgray;
}
#sceneExplorer .filter input:focus {
  box-shadow: none;
  outline: none;
  background-position: 0 0;
}
#sceneExplorer .groupContainer {
  margin-left: 0px;
  color: white;
  margin-top: 0px;
  margin-bottom: 0px;
  height: 24px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  align-self: center;
  display: grid;
  align-items: center;
}
#sceneExplorer .groupContainer:hover {
  background: #444444;
}
#sceneExplorer .groupContainer .expandableHeader {
  display: grid;
  grid-template-columns: 1fr 20px;
}
#sceneExplorer .groupContainer .expandableHeader .text {
  grid-column: 1;
  display: grid;
  grid-template-columns: 20px 1fr;
}
#sceneExplorer .groupContainer .expandableHeader .text .arrow {
  grid-column: 1;
  margin-left: 0px;
  color: white;
  cursor: pointer;
  display: inline-block;
  margin-right: 6px;
  opacity: 0.5;
}
#sceneExplorer .groupContainer .expandableHeader .text .text-value {
  grid-column: 2;
  display: flex;
  align-items: center;
}
#sceneExplorer .groupContainer .expandableHeader .expandAll {
  opacity: 0.5;
  grid-column: 2;
  margin-right: 10px;
}
#sceneExplorer .icon {
  display: grid;
  align-items: center;
  justify-items: center;
  cursor: pointer;
}
#sceneExplorer .itemContainer {
  margin-left: 0px;
  color: white;
  margin-top: 0px;
  margin-bottom: 0px;
  height: 24px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  display: grid;
  grid-template-columns: 20px 1fr;
}
#sceneExplorer .itemContainer:hover {
  background: #444444;
}
#sceneExplorer .itemContainer.selected {
  background: #bbbbbb;
  color: black;
}
#sceneExplorer .itemContainer .isNotActive {
  opacity: 0.3;
}
#sceneExplorer .itemContainer .arrow {
  grid-column: 1;
  color: white;
  opacity: 0.6;
}
#sceneExplorer .itemContainer .popup {
  width: 200px;
  visibility: hidden;
  background-color: #444444;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.5);
  position: absolute;
  z-index: 1;
  margin-left: -180px;
  box-sizing: border-box;
}
#sceneExplorer .itemContainer .popup.show {
  visibility: visible;
}
#sceneExplorer .itemContainer .popup:focus {
  outline: none;
}
#sceneExplorer .itemContainer .popup .popupMenu {
  padding: 6px 5px 5px 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  height: 18px;
}
#sceneExplorer .itemContainer .popup .popupMenu:hover {
  background: white;
  color: #333333;
}
#sceneExplorer .itemContainer .sceneNode {
  grid-column: 2;
  margin-left: -10px;
  display: grid;
  grid-template-columns: 1fr 20px 20px 20px 20px 10px 20px 20px auto 5px;
  align-items: center;
  cursor: pointer;
}
#sceneExplorer .itemContainer .sceneNode .sceneTitle {
  grid-column: 1;
  margin-right: 5px;
  display: flex;
  align-items: center;
  height: 24px;
}
#sceneExplorer .itemContainer .sceneNode .translation {
  grid-column: 2;
  opacity: 0.6;
}
#sceneExplorer .itemContainer .sceneNode .translation.selected {
  opacity: 1;
}
#sceneExplorer .itemContainer .sceneNode .rotation {
  grid-column: 3;
  opacity: 0.6;
}
#sceneExplorer .itemContainer .sceneNode .rotation.selected {
  opacity: 1;
}
#sceneExplorer .itemContainer .sceneNode .scaling {
  grid-column: 4;
  opacity: 0.6;
}
#sceneExplorer .itemContainer .sceneNode .scaling.selected {
  opacity: 1;
}
#sceneExplorer .itemContainer .sceneNode .bounding {
  grid-column: 5;
  opacity: 0.6;
}
#sceneExplorer .itemContainer .sceneNode .bounding.selected {
  opacity: 1;
}
#sceneExplorer .itemContainer .sceneNode .separator {
  grid-column: 6;
  margin-left: 5px;
  width: 5px;
  display: flex;
  align-items: center;
  height: 18px;
  border-left: solid 1px rgb(51, 122, 183);
}
#sceneExplorer .itemContainer .sceneNode .pickingMode {
  grid-column: 7;
  opacity: 0.6;
}
#sceneExplorer .itemContainer .sceneNode .pickingMode.selected {
  opacity: 1;
}
#sceneExplorer .itemContainer .sceneNode .coordinates {
  grid-column: 8;
  opacity: 0.6;
}
#sceneExplorer .itemContainer .sceneNode .coordinates.selected {
  opacity: 1;
}
#sceneExplorer .itemContainer .sceneNode .refresh {
  grid-column: 9;
}
#sceneExplorer .itemContainer .sceneNode .extensions {
  width: 20px;
  grid-column: 10;
}
#sceneExplorer .itemContainer .targetedAnimationTools {
  grid-column: 2;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr auto 5px;
  align-items: center;
  min-width: 0;
}
#sceneExplorer .itemContainer .targetedAnimationTools .extensions {
  width: 20px;
  grid-column: 2;
}
#sceneExplorer .itemContainer .animationGroupTools {
  grid-column: 2;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr auto 5px;
  align-items: center;
  min-width: 0;
}
#sceneExplorer .itemContainer .animationGroupTools .extensions {
  width: 20px;
  grid-column: 2;
}
#sceneExplorer .itemContainer .soundTools {
  grid-column: 2;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr auto 5px;
  align-items: center;
  min-width: 0;
}
#sceneExplorer .itemContainer .soundTools .extensions {
  width: 20px;
  grid-column: 2;
}
#sceneExplorer .itemContainer .meshTools {
  grid-column: 2;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 20px 20px auto 5px;
  align-items: center;
  min-width: 0;
}
#sceneExplorer .itemContainer .meshTools .bounding-box {
  grid-column: 2;
  opacity: 0.5;
}
#sceneExplorer .itemContainer .meshTools .bounding-box.selected {
  opacity: 1;
}
#sceneExplorer .itemContainer .meshTools .visibility {
  grid-column: 3;
}
#sceneExplorer .itemContainer .meshTools .extensions {
  width: 20px;
  grid-column: 4;
}
#sceneExplorer .itemContainer .cameraTools {
  grid-column: 2;
  display: grid;
  grid-template-columns: 1fr 20px 20px auto 5px;
  align-items: center;
}
#sceneExplorer .itemContainer .cameraTools .activeCamera {
  grid-column: 2;
}
#sceneExplorer .itemContainer .cameraTools .enableGizmo {
  grid-column: 3;
}
#sceneExplorer .itemContainer .cameraTools .extensions {
  width: 20px;
  grid-column: 4;
}
#sceneExplorer .itemContainer .lightTools {
  grid-column: 2;
  display: grid;
  grid-template-columns: 1fr 20px 20px auto 5px;
  align-items: center;
}
#sceneExplorer .itemContainer .lightTools .visibility {
  grid-column: 2;
}
#sceneExplorer .itemContainer .lightTools .enableGizmo {
  grid-column: 3;
}
#sceneExplorer .itemContainer .lightTools .extensions {
  width: 20px;
  grid-column: 4;
}
#sceneExplorer .itemContainer .spriteTools {
  grid-column: 2;
  display: grid;
  grid-template-columns: 1fr auto 5px;
  align-items: center;
}
#sceneExplorer .itemContainer .spriteTools .extensions {
  width: 20px;
  grid-column: 2;
}
#sceneExplorer .itemContainer .spriteManagerTools {
  grid-column: 2;
  display: grid;
  grid-template-columns: 1fr auto 5px;
  align-items: center;
}
#sceneExplorer .itemContainer .spriteManagerTools .extensions {
  width: 20px;
  grid-column: 2;
}
#sceneExplorer .itemContainer .materialTools {
  grid-column: 2;
  display: grid;
  grid-template-columns: 1fr auto 5px;
  align-items: center;
}
#sceneExplorer .itemContainer .materialTools .extensions {
  width: 20px;
  grid-column: 2;
}
#sceneExplorer .itemContainer .materialTools .icon {
  display: grid;
  align-items: center;
  justify-items: center;
  cursor: pointer;
}
#sceneExplorer .itemContainer .particleSystemTools {
  grid-column: 2;
  display: grid;
  grid-template-columns: 1fr auto 5px;
  align-items: center;
}
#sceneExplorer .itemContainer .particleSystemTools .extensions {
  width: 20px;
  grid-column: 2;
}
#sceneExplorer .itemContainer .effectLayerTools {
  grid-column: 2;
  display: grid;
  grid-template-columns: 1fr auto 5px;
  align-items: center;
}
#sceneExplorer .itemContainer .effectLayerTools .extensions {
  width: 20px;
  grid-column: 2;
}
#sceneExplorer .itemContainer .postProcessTools {
  grid-column: 2;
  display: grid;
  grid-template-columns: 1fr auto 5px;
  align-items: center;
}
#sceneExplorer .itemContainer .postProcessTools .extensions {
  width: 20px;
  grid-column: 2;
}
#sceneExplorer .itemContainer .renderingPipelineTools {
  grid-column: 2;
  display: grid;
  grid-template-columns: 1fr auto 5px;
  align-items: center;
}
#sceneExplorer .itemContainer .renderingPipelineTools .extensions {
  width: 20px;
  grid-column: 2;
}
#sceneExplorer .itemContainer .textureTools {
  grid-column: 2;
  display: grid;
  grid-template-columns: 1fr auto 5px;
  align-items: center;
}
#sceneExplorer .itemContainer .textureTools .extensions {
  width: 20px;
  grid-column: 2;
}
#sceneExplorer .itemContainer .adtextureTools {
  grid-column: 2;
  display: grid;
  grid-template-columns: 1fr 20px 20px auto 5px;
  align-items: center;
}
#sceneExplorer .itemContainer .adtextureTools .edit {
  grid-column: 2;
}
#sceneExplorer .itemContainer .adtextureTools .pickingMode {
  grid-column: 3;
  opacity: 0.6;
}
#sceneExplorer .itemContainer .adtextureTools .pickingMode.selected {
  opacity: 1;
}
#sceneExplorer .itemContainer .adtextureTools .extensions {
  width: 20px;
  grid-column: 3;
}
#sceneExplorer .itemContainer .controlTools {
  grid-column: 2;
  display: grid;
  grid-template-columns: 1fr 20px 20px auto 5px;
  align-items: center;
}
#sceneExplorer .itemContainer .controlTools .highlight {
  grid-column: 2;
}
#sceneExplorer .itemContainer .controlTools .visibility {
  grid-column: 3;
}
#sceneExplorer .itemContainer .controlTools .extensions {
  width: 20px;
  grid-column: 4;
}
#sceneExplorer .itemContainer .transformNodeTools {
  grid-column: 2;
  display: grid;
  grid-template-columns: 1fr auto 5px;
  align-items: center;
}
#sceneExplorer .itemContainer .transformNodeTools .extensions {
  width: 20px;
  grid-column: 2;
}
#sceneExplorer .itemContainer .skeletonTools {
  grid-column: 2;
  display: grid;
  grid-template-columns: 1fr auto 5px;
  align-items: center;
}
#sceneExplorer .itemContainer .skeletonTools .extensions {
  width: 20px;
  grid-column: 2;
}
#sceneExplorer .itemContainer .title {
  grid-column: 1;
  background: transparent;
  white-space: nowrap;
  overflow: hidden;
  min-width: 0;
  margin-right: 5px;
  display: grid;
  align-items: center;
  grid-template-columns: 25px 1fr;
  height: 24px;
  cursor: pointer;
}
#sceneExplorer .itemContainer .title .titleIcon {
  grid-column: 1;
  display: grid;
  align-items: center;
  justify-items: center;
}
#sceneExplorer .itemContainer .title .titleText {
  grid-column: 2;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./../../../dev/inspector/dist/components/sceneExplorer/sceneExplorer.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;AACJ;AACI;EACI,aAAA;AACR;;AAGA;EACI,aAAA;AAAJ;;AAGA;EACI,mBAAA;AAAJ;AAEI;EACI,aAAA;EACA,eAAA;AAAR;AAEQ;EACI,mBAAA;AAAZ;;AAKA;EACI,WAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,mBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,4BAAA;EACA,kBAAA;AAFJ;AAII;EACI,aAAA;AAFR;AAKI;EACI,YAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,oCAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;AAHR;AAKQ;EACI,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,aAAA;EACA,kBAAA;EACA,oBAAA;AAHZ;AAMQ;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAJZ;AAOQ;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AALZ;AAOY;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AALhB;AAQY;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AANhB;AAWI;EACI,WAAA;EAEA,kBAAA;EACA,gBAAA;AAVR;AAaI;EACI,aAAA;EACA,oBAAA;AAXR;AAaQ;EACI,WAAA;EACA,0BAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,0CAAA;EACA,wFAAA;EACA,8BAAA;EACA,4BAAA;EACA,4BAAA;EACA,YAAA;AAXZ;AAcQ;EACI,gBAAA;AAZZ;AAeQ;EACI,gBAAA;EACA,aAAA;EACA,wBAAA;AAbZ;AAiBI;EACI,gBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EAEA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EAEA,kBAAA;EACA,aAAA;EACA,mBAAA;AAjBR;AAmBQ;EACI,mBAAA;AAjBZ;AAoBQ;EACI,aAAA;EACA,+BAAA;AAlBZ;AAoBY;EACI,cAAA;EACA,aAAA;EACA,+BAAA;AAlBhB;AAoBgB;EACI,cAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,YAAA;AAlBpB;AAqBgB;EACI,cAAA;EACA,aAAA;EACA,mBAAA;AAnBpB;AAuBY;EACI,YAAA;EACA,cAAA;EACA,kBAAA;AArBhB;AA0BI;EACI,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AAxBR;AA2BI;EACI,gBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EACA,aAAA;EACA,+BAAA;AAzBR;AA2BQ;EACI,mBAAA;AAzBZ;AA4BQ;EACI,mBAAA;EACA,YAAA;AA1BZ;AA6BQ;EACI,YAAA;AA3BZ;AA8BQ;EACI,cAAA;EACA,YAAA;EACA,YAAA;AA5BZ;AA+BQ;EACI,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,sBAAA;AA7BZ;AA+BY;EACI,mBAAA;AA7BhB;AAgCY;EACI,aAAA;AA9BhB;AAiCY;EACI,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AA/BhB;AAiCgB;EACI,iBAAA;EACA,cAAA;AA/BpB;AAoCQ;EACI,cAAA;EACA,kBAAA;EACA,aAAA;EACA,sEAAA;EACA,mBAAA;EACA,eAAA;AAlCZ;AAoCY;EACI,cAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAlChB;AAqCY;EACI,cAAA;EACA,YAAA;AAnChB;AAqCgB;EACI,UAAA;AAnCpB;AAuCY;EACI,cAAA;EACA,YAAA;AArChB;AAuCgB;EACI,UAAA;AArCpB;AAyCY;EACI,cAAA;EACA,YAAA;AAvChB;AAwCgB;EACI,UAAA;AAtCpB;AA0CY;EACI,cAAA;EACA,YAAA;AAxChB;AAyCgB;EACI,UAAA;AAvCpB;AA2CY;EACI,cAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,wCAAA;AAzChB;AA4CY;EACI,cAAA;EACA,YAAA;AA1ChB;AA4CgB;EACI,UAAA;AA1CpB;AA8CY;EACI,cAAA;EACA,YAAA;AA5ChB;AA8CgB;EACI,UAAA;AA5CpB;AAgDY;EACI,cAAA;AA9ChB;AAiDY;EACI,WAAA;EACA,eAAA;AA/ChB;AAmDQ;EACI,cAAA;EACA,WAAA;EACA,aAAA;EACA,mCAAA;EACA,mBAAA;EACA,YAAA;AAjDZ;AAmDY;EACI,WAAA;EACA,cAAA;AAjDhB;AAqDQ;EACI,cAAA;EACA,WAAA;EACA,aAAA;EACA,mCAAA;EACA,mBAAA;EACA,YAAA;AAnDZ;AAqDY;EACI,WAAA;EACA,cAAA;AAnDhB;AAuDQ;EACI,cAAA;EACA,WAAA;EACA,aAAA;EACA,mCAAA;EACA,mBAAA;EACA,YAAA;AArDZ;AAuDY;EACI,WAAA;EACA,cAAA;AArDhB;AAyDQ;EACI,cAAA;EACA,WAAA;EACA,aAAA;EACA,6CAAA;EACA,mBAAA;EACA,YAAA;AAvDZ;AAyDY;EACI,cAAA;EACA,YAAA;AAvDhB;AAyDgB;EACI,UAAA;AAvDpB;AA2DY;EACI,cAAA;AAzDhB;AA4DY;EACI,WAAA;EACA,cAAA;AA1DhB;AA8DQ;EACI,cAAA;EACA,aAAA;EACA,6CAAA;EACA,mBAAA;AA5DZ;AA8DY;EACI,cAAA;AA5DhB;AA+DY;EACI,cAAA;AA7DhB;AAgEY;EACI,WAAA;EACA,cAAA;AA9DhB;AAkEQ;EACI,cAAA;EACA,aAAA;EACA,6CAAA;EACA,mBAAA;AAhEZ;AAkEY;EACI,cAAA;AAhEhB;AAmEY;EACI,cAAA;AAjEhB;AAoEY;EACI,WAAA;EACA,cAAA;AAlEhB;AAsEQ;EACI,cAAA;EACA,aAAA;EACA,mCAAA;EACA,mBAAA;AApEZ;AAsEY;EACI,WAAA;EACA,cAAA;AApEhB;AAwEQ;EACI,cAAA;EACA,aAAA;EACA,mCAAA;EACA,mBAAA;AAtEZ;AAwEY;EACI,WAAA;EACA,cAAA;AAtEhB;AA0EQ;EACI,cAAA;EACA,aAAA;EACA,mCAAA;EACA,mBAAA;AAxEZ;AA0EY;EACI,WAAA;EACA,cAAA;AAxEhB;AA2EY;EACI,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AAzEhB;AA6EQ;EACI,cAAA;EACA,aAAA;EACA,mCAAA;EACA,mBAAA;AA3EZ;AA6EY;EACI,WAAA;EACA,cAAA;AA3EhB;AA+EQ;EACI,cAAA;EACA,aAAA;EACA,mCAAA;EACA,mBAAA;AA7EZ;AA+EY;EACI,WAAA;EACA,cAAA;AA7EhB;AAiFQ;EACI,cAAA;EACA,aAAA;EACA,mCAAA;EACA,mBAAA;AA/EZ;AAiFY;EACI,WAAA;EACA,cAAA;AA/EhB;AAmFQ;EACI,cAAA;EACA,aAAA;EACA,mCAAA;EACA,mBAAA;AAjFZ;AAmFY;EACI,WAAA;EACA,cAAA;AAjFhB;AAqFQ;EACI,cAAA;EACA,aAAA;EACA,mCAAA;EACA,mBAAA;AAnFZ;AAqFY;EACI,WAAA;EACA,cAAA;AAnFhB;AAuFQ;EACI,cAAA;EACA,aAAA;EACA,6CAAA;EACA,mBAAA;AArFZ;AAuFY;EACI,cAAA;AArFhB;AAwFY;EACI,cAAA;EACA,YAAA;AAtFhB;AAwFgB;EACI,UAAA;AAtFpB;AA0FY;EACI,WAAA;EACA,cAAA;AAxFhB;AA4FQ;EACI,cAAA;EACA,aAAA;EACA,6CAAA;EACA,mBAAA;AA1FZ;AA4FY;EACI,cAAA;AA1FhB;AA6FY;EACI,cAAA;AA3FhB;AA8FY;EACI,WAAA;EACA,cAAA;AA5FhB;AAgGQ;EACI,cAAA;EACA,aAAA;EACA,mCAAA;EACA,mBAAA;AA9FZ;AAgGY;EACI,WAAA;EACA,cAAA;AA9FhB;AAkGQ;EACI,cAAA;EACA,aAAA;EACA,mCAAA;EACA,mBAAA;AAhGZ;AAkGY;EACI,WAAA;EACA,cAAA;AAhGhB;AAoGQ;EACI,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,+BAAA;EACA,YAAA;EACA,eAAA;AAlGZ;AAoGY;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;AAlGhB;AAqGY;EACI,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAnGhB","sourcesContent":["#scene-explorer-host {\r\n    position: absolute;\r\n    left: 0px;\r\n    top: 0px;\r\n    bottom: 0px;\r\n\r\n    &:focus {\r\n        outline: none;\r\n    }\r\n}\r\n\r\n#__resizable_base__ {\r\n    display: none;\r\n}\r\n\r\n.context-menu {\r\n    background: #222222;\r\n\r\n    .react-contextmenu-item {\r\n        padding: 10px;\r\n        cursor: pointer;\r\n\r\n        &:hover {\r\n            background: #555555;\r\n        }\r\n    }\r\n}\r\n\r\n.react-contextmenu.context-menu.react-contextmenu--visible {\r\n    z-index: 99;\r\n    transform: scale(1);\r\n}\r\n\r\n#sceneExplorer {\r\n    background: #333333;\r\n    height: 100%;\r\n    margin: 0;\r\n    padding: 0;\r\n    display: grid;\r\n    grid-template-rows: auto 1fr;\r\n    font: 14px \"Arial\";\r\n\r\n    &:focus {\r\n        outline: none;\r\n    }\r\n\r\n    #header {\r\n        height: 30px;\r\n        font-size: 16px;\r\n        color: white;\r\n        background: #222222;\r\n        grid-row: 1;\r\n        text-align: center;\r\n        display: grid;\r\n        grid-template-columns: 30px 1fr 50px;\r\n        -webkit-user-select: none;\r\n        -moz-user-select: none;\r\n        -ms-user-select: none;\r\n        user-select: none;\r\n\r\n        #logo {\r\n            position: relative;\r\n            grid-column: 1;\r\n            width: 24px;\r\n            height: 24px;\r\n            left: 0;\r\n            display: flex;\r\n            align-self: center;\r\n            justify-self: center;\r\n        }\r\n\r\n        #title {\r\n            grid-column: 2;\r\n            display: grid;\r\n            align-items: center;\r\n            text-align: center;\r\n        }\r\n\r\n        #commands {\r\n            grid-column: 3;\r\n            display: grid;\r\n            align-items: center;\r\n            grid-template-columns: 1fr 1fr;\r\n\r\n            .expand {\r\n                grid-column: 1;\r\n                display: grid;\r\n                align-items: center;\r\n                justify-items: center;\r\n                cursor: pointer;\r\n            }\r\n\r\n            .close {\r\n                grid-column: 2;\r\n                display: grid;\r\n                align-items: center;\r\n                justify-items: center;\r\n                cursor: pointer;\r\n            }\r\n        }\r\n    }\r\n\r\n    #tree {\r\n        grid-row: 2;\r\n\r\n        overflow-x: hidden;\r\n        overflow-y: auto;\r\n    }\r\n\r\n    .filter {\r\n        display: flex;\r\n        align-items: stretch;\r\n\r\n        input {\r\n            width: 100%;\r\n            margin: 10px 40px 5px 40px;\r\n            display: block;\r\n            border: none;\r\n            padding: 0;\r\n            border-bottom: solid 1px rgb(51, 122, 183);\r\n            background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 96%, rgb(51, 122, 183) 4%);\r\n            background-position: -1000px 0;\r\n            background-size: 1000px 100%;\r\n            background-repeat: no-repeat;\r\n            color: white;\r\n        }\r\n\r\n        input::placeholder {\r\n            color: lightgray;\r\n        }\r\n\r\n        input:focus {\r\n            box-shadow: none;\r\n            outline: none;\r\n            background-position: 0 0;\r\n        }\r\n    }\r\n\r\n    .groupContainer {\r\n        margin-left: 0px;\r\n        color: white;\r\n        margin-top: 0px;\r\n        margin-bottom: 0px;\r\n        height: 24px;\r\n\r\n        -webkit-user-select: none;\r\n        -moz-user-select: none;\r\n        -ms-user-select: none;\r\n        user-select: none;\r\n\r\n        align-self: center;\r\n        display: grid;\r\n        align-items: center;\r\n\r\n        &:hover {\r\n            background: #444444;\r\n        }\r\n\r\n        .expandableHeader {\r\n            display: grid;\r\n            grid-template-columns: 1fr 20px;\r\n\r\n            .text {\r\n                grid-column: 1;\r\n                display: grid;\r\n                grid-template-columns: 20px 1fr;\r\n\r\n                .arrow {\r\n                    grid-column: 1;\r\n                    margin-left: 0px;\r\n                    color: white;\r\n                    cursor: pointer;\r\n                    display: inline-block;\r\n                    margin-right: 6px;\r\n                    opacity: 0.5;\r\n                }\r\n\r\n                .text-value {\r\n                    grid-column: 2;\r\n                    display: flex;\r\n                    align-items: center;\r\n                }\r\n            }\r\n\r\n            .expandAll {\r\n                opacity: 0.5;\r\n                grid-column: 2;\r\n                margin-right: 10px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .icon {\r\n        display: grid;\r\n        align-items: center;\r\n        justify-items: center;\r\n        cursor: pointer;\r\n    }\r\n\r\n    .itemContainer {\r\n        margin-left: 0px;\r\n        color: white;\r\n        margin-top: 0px;\r\n        margin-bottom: 0px;\r\n        height: 24px;\r\n        -webkit-user-select: none;\r\n        -moz-user-select: none;\r\n        -ms-user-select: none;\r\n        user-select: none;\r\n        display: grid;\r\n        grid-template-columns: 20px 1fr;\r\n\r\n        &:hover {\r\n            background: #444444;\r\n        }\r\n\r\n        &.selected {\r\n            background: #bbbbbb;\r\n            color: black;\r\n        }\r\n\r\n        .isNotActive {\r\n            opacity: 0.3;\r\n        }\r\n\r\n        .arrow {\r\n            grid-column: 1;\r\n            color: white;\r\n            opacity: 0.6;\r\n        }\r\n\r\n        .popup {\r\n            width: 200px;\r\n            visibility: hidden;\r\n            background-color: #444444;\r\n            color: #fff;\r\n            border: 1px solid rgba(255, 255, 255, 0.5);\r\n            position: absolute;\r\n            z-index: 1;\r\n            margin-left: -180px;\r\n            box-sizing: border-box;\r\n\r\n            &.show {\r\n                visibility: visible;\r\n            }\r\n\r\n            &:focus {\r\n                outline: none;\r\n            }\r\n\r\n            .popupMenu {\r\n                padding: 6px 5px 5px 10px;\r\n                overflow: hidden;\r\n                white-space: nowrap;\r\n                text-overflow: ellipsis;\r\n                height: 18px;\r\n\r\n                &:hover {\r\n                    background: white;\r\n                    color: #333333;\r\n                }\r\n            }\r\n        }\r\n\r\n        .sceneNode {\r\n            grid-column: 2;\r\n            margin-left: -10px;\r\n            display: grid;\r\n            grid-template-columns: 1fr 20px 20px 20px 20px 10px 20px 20px auto 5px;\r\n            align-items: center;\r\n            cursor: pointer;\r\n\r\n            .sceneTitle {\r\n                grid-column: 1;\r\n                margin-right: 5px;\r\n                display: flex;\r\n                align-items: center;\r\n                height: 24px;\r\n            }\r\n\r\n            .translation {\r\n                grid-column: 2;\r\n                opacity: 0.6;\r\n\r\n                &.selected {\r\n                    opacity: 1;\r\n                }\r\n            }\r\n\r\n            .rotation {\r\n                grid-column: 3;\r\n                opacity: 0.6;\r\n\r\n                &.selected {\r\n                    opacity: 1;\r\n                }\r\n            }\r\n\r\n            .scaling {\r\n                grid-column: 4;\r\n                opacity: 0.6;\r\n                &.selected {\r\n                    opacity: 1;\r\n                }\r\n            }\r\n\r\n            .bounding {\r\n                grid-column: 5;\r\n                opacity: 0.6;\r\n                &.selected {\r\n                    opacity: 1;\r\n                }\r\n            }\r\n\r\n            .separator {\r\n                grid-column: 6;\r\n                margin-left: 5px;\r\n                width: 5px;\r\n                display: flex;\r\n                align-items: center;\r\n                height: 18px;\r\n                border-left: solid 1px rgb(51, 122, 183);\r\n            }\r\n\r\n            .pickingMode {\r\n                grid-column: 7;\r\n                opacity: 0.6;\r\n\r\n                &.selected {\r\n                    opacity: 1;\r\n                }\r\n            }\r\n\r\n            .coordinates {\r\n                grid-column: 8;\r\n                opacity: 0.6;\r\n\r\n                &.selected {\r\n                    opacity: 1;\r\n                }\r\n            }\r\n\r\n            .refresh {\r\n                grid-column: 9;\r\n            }\r\n\r\n            .extensions {\r\n                width: 20px;\r\n                grid-column: 10;\r\n            }\r\n        }\r\n\r\n        .targetedAnimationTools {\r\n            grid-column: 2;\r\n            width: 100%;\r\n            display: grid;\r\n            grid-template-columns: 1fr auto 5px;\r\n            align-items: center;\r\n            min-width: 0;\r\n\r\n            .extensions {\r\n                width: 20px;\r\n                grid-column: 2;\r\n            }\r\n        }\r\n\r\n        .animationGroupTools {\r\n            grid-column: 2;\r\n            width: 100%;\r\n            display: grid;\r\n            grid-template-columns: 1fr auto 5px;\r\n            align-items: center;\r\n            min-width: 0;\r\n\r\n            .extensions {\r\n                width: 20px;\r\n                grid-column: 2;\r\n            }\r\n        }\r\n\r\n        .soundTools {\r\n            grid-column: 2;\r\n            width: 100%;\r\n            display: grid;\r\n            grid-template-columns: 1fr auto 5px;\r\n            align-items: center;\r\n            min-width: 0;\r\n\r\n            .extensions {\r\n                width: 20px;\r\n                grid-column: 2;\r\n            }\r\n        }\r\n\r\n        .meshTools {\r\n            grid-column: 2;\r\n            width: 100%;\r\n            display: grid;\r\n            grid-template-columns: 1fr 20px 20px auto 5px;\r\n            align-items: center;\r\n            min-width: 0;\r\n\r\n            .bounding-box {\r\n                grid-column: 2;\r\n                opacity: 0.5;\r\n\r\n                &.selected {\r\n                    opacity: 1;\r\n                }\r\n            }\r\n\r\n            .visibility {\r\n                grid-column: 3;\r\n            }\r\n\r\n            .extensions {\r\n                width: 20px;\r\n                grid-column: 4;\r\n            }\r\n        }\r\n\r\n        .cameraTools {\r\n            grid-column: 2;\r\n            display: grid;\r\n            grid-template-columns: 1fr 20px 20px auto 5px;\r\n            align-items: center;\r\n\r\n            .activeCamera {\r\n                grid-column: 2;\r\n            }\r\n\r\n            .enableGizmo {\r\n                grid-column: 3;\r\n            }\r\n\r\n            .extensions {\r\n                width: 20px;\r\n                grid-column: 4;\r\n            }\r\n        }\r\n\r\n        .lightTools {\r\n            grid-column: 2;\r\n            display: grid;\r\n            grid-template-columns: 1fr 20px 20px auto 5px;\r\n            align-items: center;\r\n\r\n            .visibility {\r\n                grid-column: 2;\r\n            }\r\n\r\n            .enableGizmo {\r\n                grid-column: 3;\r\n            }\r\n\r\n            .extensions {\r\n                width: 20px;\r\n                grid-column: 4;\r\n            }\r\n        }\r\n\r\n        .spriteTools {\r\n            grid-column: 2;\r\n            display: grid;\r\n            grid-template-columns: 1fr auto 5px;\r\n            align-items: center;\r\n\r\n            .extensions {\r\n                width: 20px;\r\n                grid-column: 2;\r\n            }\r\n        }\r\n\r\n        .spriteManagerTools {\r\n            grid-column: 2;\r\n            display: grid;\r\n            grid-template-columns: 1fr auto 5px;\r\n            align-items: center;\r\n\r\n            .extensions {\r\n                width: 20px;\r\n                grid-column: 2;\r\n            }\r\n        }\r\n\r\n        .materialTools {\r\n            grid-column: 2;\r\n            display: grid;\r\n            grid-template-columns: 1fr auto 5px;\r\n            align-items: center;\r\n\r\n            .extensions {\r\n                width: 20px;\r\n                grid-column: 2;\r\n            }\r\n\r\n            .icon {\r\n                display: grid;\r\n                align-items: center;\r\n                justify-items: center;\r\n                cursor: pointer;\r\n            }\r\n        }\r\n\r\n        .particleSystemTools {\r\n            grid-column: 2;\r\n            display: grid;\r\n            grid-template-columns: 1fr auto 5px;\r\n            align-items: center;\r\n\r\n            .extensions {\r\n                width: 20px;\r\n                grid-column: 2;\r\n            }\r\n        }\r\n\r\n        .effectLayerTools {\r\n            grid-column: 2;\r\n            display: grid;\r\n            grid-template-columns: 1fr auto 5px;\r\n            align-items: center;\r\n\r\n            .extensions {\r\n                width: 20px;\r\n                grid-column: 2;\r\n            }\r\n        }\r\n\r\n        .postProcessTools {\r\n            grid-column: 2;\r\n            display: grid;\r\n            grid-template-columns: 1fr auto 5px;\r\n            align-items: center;\r\n\r\n            .extensions {\r\n                width: 20px;\r\n                grid-column: 2;\r\n            }\r\n        }\r\n\r\n        .renderingPipelineTools {\r\n            grid-column: 2;\r\n            display: grid;\r\n            grid-template-columns: 1fr auto 5px;\r\n            align-items: center;\r\n\r\n            .extensions {\r\n                width: 20px;\r\n                grid-column: 2;\r\n            }\r\n        }\r\n\r\n        .textureTools {\r\n            grid-column: 2;\r\n            display: grid;\r\n            grid-template-columns: 1fr auto 5px;\r\n            align-items: center;\r\n\r\n            .extensions {\r\n                width: 20px;\r\n                grid-column: 2;\r\n            }\r\n        }\r\n\r\n        .adtextureTools {\r\n            grid-column: 2;\r\n            display: grid;\r\n            grid-template-columns: 1fr 20px 20px auto 5px;\r\n            align-items: center;\r\n\r\n            .edit {\r\n                grid-column: 2;\r\n            }\r\n\r\n            .pickingMode {\r\n                grid-column: 3;\r\n                opacity: 0.6;\r\n\r\n                &.selected {\r\n                    opacity: 1;\r\n                }\r\n            }\r\n\r\n            .extensions {\r\n                width: 20px;\r\n                grid-column: 3;\r\n            }\r\n        }\r\n\r\n        .controlTools {\r\n            grid-column: 2;\r\n            display: grid;\r\n            grid-template-columns: 1fr 20px 20px auto 5px;\r\n            align-items: center;\r\n\r\n            .highlight {\r\n                grid-column: 2;\r\n            }\r\n\r\n            .visibility {\r\n                grid-column: 3;\r\n            }\r\n\r\n            .extensions {\r\n                width: 20px;\r\n                grid-column: 4;\r\n            }\r\n        }\r\n\r\n        .transformNodeTools {\r\n            grid-column: 2;\r\n            display: grid;\r\n            grid-template-columns: 1fr auto 5px;\r\n            align-items: center;\r\n\r\n            .extensions {\r\n                width: 20px;\r\n                grid-column: 2;\r\n            }\r\n        }\r\n\r\n        .skeletonTools {\r\n            grid-column: 2;\r\n            display: grid;\r\n            grid-template-columns: 1fr auto 5px;\r\n            align-items: center;\r\n\r\n            .extensions {\r\n                width: 20px;\r\n                grid-column: 2;\r\n            }\r\n        }\r\n\r\n        .title {\r\n            grid-column: 1;\r\n            background: transparent;\r\n            white-space: nowrap;\r\n            overflow: hidden;\r\n            min-width: 0;\r\n            margin-right: 5px;\r\n            display: grid;\r\n            align-items: center;\r\n            grid-template-columns: 25px 1fr;\r\n            height: 24px;\r\n            cursor: pointer;\r\n\r\n            .titleIcon {\r\n                grid-column: 1;\r\n                display: grid;\r\n                align-items: center;\r\n                justify-items: center;\r\n            }\r\n\r\n            .titleText {\r\n                grid-column: 2;\r\n                white-space: nowrap;\r\n                text-overflow: ellipsis;\r\n                overflow: hidden;\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
